import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListPayoutComponent } from './list-payout/list-payout.component';

const routes: Routes = [
  {
    path: '',
    component: ListPayoutComponent,
  },

  { path: '', pathMatch: 'full', redirectTo: 'catalog/payout' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PayoutRoutingModule {}
